import { logCustomAttributeToNewRelic, logPageActionToNewRelic } from "../newRelic-log-utils";
import { MONITORING_SCHEMA_EVENT } from "./constants";
import { installFetchMonitoring } from "./fetch-monitoring";
import { installPromptMonitoring } from "./prompt-monitoring";
import type { InstallMonitoringOptions } from "./types";
import { installXhrMonitoring } from "./xhr-monitoring";

// Installs shared monitoring hooks and reports the loaded schema to New Relic.
export function installMonitoring(options: InstallMonitoringOptions): () => void {
  if (typeof window === "undefined") {
    return () => undefined;
  }

  const cleanups: Array<() => void> = [];

  logCustomAttributeToNewRelic("monitoring_pod", options.schema.pod, true);
  logCustomAttributeToNewRelic("monitoring_schema_id", options.schema.schemaId, true);
  logPageActionToNewRelic(MONITORING_SCHEMA_EVENT, {
    pod: options.schema.pod,
    schema_id: options.schema.schemaId,
    active_metric_count: options.schema.metrics.filter((metric) => metric.status === "active")
      .length,
    planned_metric_count: options.schema.metrics.filter((metric) => metric.status === "planned")
      .length,
  });

  if (options.observeFetch !== false) {
    cleanups.push(installFetchMonitoring(options.schema));
  }

  if (options.observeXhr !== false) {
    cleanups.push(installXhrMonitoring(options.schema));
  }

  if (options.observePrompt !== false) {
    cleanups.push(installPromptMonitoring(options.schema));
  }

  return () => {
    const cleanupQueue = [...cleanups].reverse();

    for (const cleanup of cleanupQueue) {
      cleanup();
    }
  };
}
